import { render } from "./VUEDataRow.vue?vue&type=template&id=76bcbddd"
import script from "./VUEDataRow.vue?vue&type=script&lang=js"
export * from "./VUEDataRow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__